import React 			from 'react';
import PropTypes 	from 'prop-types';

import BLComponent from '../core/_BLComponent.jsx'

//this.props.classes	: string of classes
//this.props.data			: {id: string, focus: boolean, label: string, inputValue: state, onChangeFunc: setState function, type: string, password: boolean, validation: ok || error}

export default class InputLabelSet extends BLComponent
{
	constructor( props )
	{
		super( props );

		this.state = {
			showPassword: false
		};

		this.id 	= this.generateId();
	}

	render() 
	{
		const {classes = '', data, isTight} = this.props;
		return (
			<div className={"input-label-set " + classes + (data.password ? ' input-password-toggle' : '') + (data.hasClear ? ' input-label-set--with-clear' : '') + (isTight ? ' input-label-set--tight' : '') + (data.disabled ? ' input-label-set--disabled' : '')}>
				<div className="l-relative l-full-width">
					<input autoFocus={data.focus} placeholder={data.placeholder} type={this.state.showPassword ? 'text' : (data.type ? data.type : 'text')} id={data.id ? data.id : this.id} disabled={data.disabled} className={"text-input input-label-set__input" + (data.password ? ' input-password-toggle__input' : '') + (data.validation ? ' input-label-set__input--validation' : '') + (data.validation == 'error' ? ' input-label-set__input--validation--error' : '') + (data.hasClear ? ' input-label-set__input--with-clear' : '')} value={data.inputValue} maxLength={data.maxLength} onChange={this.onChange} onKeyDown={this.onKeyDown}/>
					<label htmlFor={data.id ? data.id : this.id} className={ ( ( data.inputValue && ( data.inputValue.toString().length > 0 ) ) || data.type == "date" ? 'has-content ' : '' ) + "input-label-set__label"}>{data.label}</label>
					{data.validation ? 
						<i className={"input-label-set__validation-icon fa-fw " + (data.validation == 'ok' ? "fas fa-check text-color--primaryGreen" : "fas fa-exclamation-triangle text-color--primaryRed")}/>
					: null}
				</div>
				{data.password ? 
					<button className="input-password-toggle__btn btn btn--grey" onClick={() => this.togglePassword()}><i className={"far fa-fw " + (this.state.showPassword ? 'fa-eye' : 'fa-eye-slash')}/></button>
				: null}
				{data.hasClear && data.inputValue ? 
					<button className="input-label-set__clear-btn btn btn--blank" onClick={() => this.props.data.onChangeFunc('')}><i className={"fas fa-times-circle"}/></button>
				: null}
			</div>
		);
	}

	togglePassword = (e) =>
	{
		this.setState({showPassword: !this.state.showPassword});
	}

	onChange = (e) => 
	{
		if ( typeof this.props.data.onChangeFunc == "function" )
			this.props.data.onChangeFunc( e.target.value );
	}

	onKeyDown = (e) =>
	{
		if ( e.keyCode == 13 ) 
		{
			e.preventDefault(); 
			e.stopPropagation(); 
			if ( typeof this.props.data.onEnterFunc == "function" )
				this.props.data.onEnterFunc();
		}
	}

	generateId()
	{
		return Math.random().toString(36).substring(7) + Math.random().toString(36).substring(7);
	}
}

InputLabelSet.propTypes = {
		classes: PropTypes.string
	,	isTight: PropTypes.bool
	,	data: PropTypes.shape({
				id: PropTypes.string
			,	focus: PropTypes.bool
			,	disabled: PropTypes.bool
			,	label: PropTypes.string.isRequired
			,	placeholder: PropTypes.string
			,	inputValue: PropTypes.string
			, onChangeFunc: function(props, propName, componentName) {
					if(props['disabled'] === undefined && props[propName] == undefined) return new Error('You must provide and onChangeFunc with type of function if the field isnt disabled')
				}
			, onEnterFunc: PropTypes.func
			, type: PropTypes.string
			, password: PropTypes.bool
			, validation: PropTypes.oneOf(['ok', 'error', ''])
			,	hasClear: PropTypes.bool
		}).isRequired
	,
}